import React from 'react';
import { CALL_TYPE_IN, CALL_TYPE_OUT, STATUS_BLOCKED, CALL_TYPE_ALL } from '../../../Constants';
import '../../../styles.css';
import { useTranslation } from 'react-i18next';
import DesktopDataGrid from "../../DesktopDataGrid";
import { formatLocalPhone } from '../../../Helper';


export default function BlockCategory(props) {
  const { t } = useTranslation();

  const columns = [
    { field: 'number', headerName: t('Number'),
      renderCell: (cellValues) => (
        <div className='bl-number-cell'>
          <span className='bl-number'>{formatLocalPhone(cellValues.number)}</span>
          <button className='bl-act bl-act--edit' title={t('Edit')} onClick={(e) => { e.stopPropagation(); props.displayEditPopup(cellValues); }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
          </button>
        </div>
      )
    },
    { field: 'status', headerName: t('Status'), sortable:false,
      renderCell: (row) => (
        <span className={'bl-status ' + (row.status === STATUS_BLOCKED ? 'bl-status--blocked' : 'bl-status--open')}>
          {row.status === STATUS_BLOCKED ? t("Blocked") : t("Open")}
        </span>
      )
    },
    { field: 'active', headerName: t('Is Active'),
      renderCell: (row) => (
        row.active === 0 ?
        <span className='bl-active bl-active--off' title={t('Is Active')}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </span> :
        <span className='bl-active bl-active--on' title={t('Is Active')}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        </span>
      )
    },
    { field: 'call_type', headerName: t('Call Type'),
      valueGetter: (row) => {
        let label = null;
        if(row.call_type === CALL_TYPE_OUT){
          label = t("Outgoing");
        }
        if(row.call_type === CALL_TYPE_IN){
          label = t("Incoming");
        }
        if(row.call_type === CALL_TYPE_ALL){
          label = t("Both");
        }
        return label;
      }
    },
    { field: 'note', headerName: t('Note')},
    {
      field: 'delete', headerName: "",
      renderCell: (cellValues) => (
        <button className='bl-act bl-act--del' title={t('Delete 2')} onClick={(e) => props.handleDeleteRow(cellValues)}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
        </button>
      )
    }
  ];

  return (
    <div className="customer-blocks-popup ci-redesign bl-redesign">
      <div className="ci-override-notice">
        <div className='ci-override-notice-icon'>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <div className='ci-override-notice-text'>
          {t("Please note that the configurations on customer and line level will precede the community configurations.")}
        </div>
      </div>

      <div className='ci-section'>
        <div className='ci-section-head'>
          <div className='ci-section-title-wrap'>
            <h3 className='ci-section-title'>רשימת חסימה</h3>
          </div>
          <div className='bl-head-actions'>
            <div className='bl-search'>
              <svg className='bl-search-icon' width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input
                type="text"
                placeholder={t("Search number in the list")}
                onChange={(e)=>{props.changeSearchFilters(e, "number")}}
              />
            </div>
            <button className='bl-add-btn' onClick={() => props.handleAddRow()}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              <span>{t("Add a row")}</span>
            </button>
          </div>
        </div>
        <DesktopDataGrid
          rowCount={props.rowCount}
          rows={props.rows}
          columns={columns}
          page={props.page}
          pageSize={props.pageSize}
          onPageChange={(newPage) => {
            props.setPage(newPage);
          }}
          onPageSizeChange={(newPageSize) => {
            props.setPageSize(newPageSize);
          }}
          expandedRowIds={props.expandedRowIds}
          setExpandedRowIds={props.setExpandedRowIds}
          />
      </div>
    </div>
  );
}
